import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';

export type LinkedHeaderProps = {
    linkUrl: string;
    title: JSX.Element | React.ReactNode | string;
    icon: JSX.Element | React.ReactNode;
    viewMoreMarkedNoFollow?: boolean;
    enableClientSideLinking?: boolean;
};
export const LinkedHeaderTitle: React.FunctionComponent<LinkedHeaderProps> = (
    props,
) => {
    return props.enableClientSideLinking ? (
        <h2 className="header__text">
            <Link
                className="eds-text-hs"
                to={props.linkUrl}
                aria-label={gettext('View more %(title)s', {
                    title: props.title,
                }).toString()}
                rel={props.viewMoreMarkedNoFollow ? 'nofollow' : ''}
            >
                {props.title}
                {props.icon}
            </Link>
        </h2>
    ) : (
        <h2 className="header__text">
            <a
                className="eds-text-hs"
                href={props.linkUrl}
                aria-label={gettext('View more %(title)s', {
                    title: props.title,
                }).toString()}
                rel={props.viewMoreMarkedNoFollow ? 'nofollow' : ''}
            >
                {props.title}
                {props.icon}
            </a>
        </h2>
    );
};
